
<template>
   <div class="">
       <FormMeta :submit-function="createMeta" />
   </div>
</template>

<script>
import FormMeta from './FormMeta'

export default {
  name: "tableItems",
  components:{FormMeta},
  data() {
    return {};
  },
  methods:{
    createMeta(form){
      this.$store.dispatch('Meta/createmetas',form)
    }
  },
  mounted() {
    console.log('alsdmlkasd')
  }
};
</script>